"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntermediateCatchEventViewModel = void 0;
const index_1 = require("../../Model/Events/index");
const EventBaseViewModel_1 = require("./EventBaseViewModel");
class IntermediateCatchEventViewModel extends EventBaseViewModel_1.EventViewModel {
    constructor(intermediateCatchEvent, processModel) {
        var _a, _b, _c, _d;
        super(intermediateCatchEvent, processModel);
        this.linkName = (_a = intermediateCatchEvent.linkEventDefinition) === null || _a === void 0 ? void 0 : _a.name;
        this.timerType = ((_b = intermediateCatchEvent.timerEventDefinition) === null || _b === void 0 ? void 0 : _b.timerType) ?
            index_1.TimerType[(_c = intermediateCatchEvent.timerEventDefinition) === null || _c === void 0 ? void 0 : _c.timerType] : null;
        this.timerValue = (_d = intermediateCatchEvent.timerEventDefinition) === null || _d === void 0 ? void 0 : _d.value;
    }
}
exports.IntermediateCatchEventViewModel = IntermediateCatchEventViewModel;
//# sourceMappingURL=IntermediateCatchEventViewModel.js.map